import { Injectable, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddressBookComponent } from '../shared/components/address-book/address-book.component';
import { AnalyticsService } from './analytics.service';
import { ShopService } from './shop.service';
import { StorageService } from './storage.service';

/** One place that opens the address book, used by the header and page-level "set location" prompts. */
@Injectable({ providedIn: 'root' })
export class LocationPickerService {
  private modalService = inject(NgbModal);
  private analytics = inject(AnalyticsService);
  private shopService = inject(ShopService);
  private storage = inject(StorageService);

  open(): void {
    // Guards against a duplicate modal (e.g. a click replayed by hydration event-replay).
    if (this.modalService.hasOpenModals()) return;
    this.analytics.trackEvent('SELECT_LOCATION_CLICKED', 'EVENT_TRIGGERED', 1);
    const modalRef = this.modalService.open(AddressBookComponent, {
      ariaLabelledBy: 'address-book-title',
      centered: true,
      size: 'md',
      scrollable: true,
    });
    modalRef.result.then(
      () => this.shopService.setRadius(Number(this.storage.getItem('radius')) || 1),
      () => { },
    );
  }
}
